/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button/Button';
import {
    object, func, shape, string, bool, arrayOf,
} from 'prop-types';
import CardInside from './CardInside';
import CardFrontSide from './CardFrontSide';

const styles = (theme) => ({
    saveButton: {
        width: '100%',
        padding: '8px 12px',
        outline: 'none',
        border: 'none',
        color: theme.palette.cgc?.white || 'white',
        borderRadius: 4,
        background: theme.palette.cgc?.bgSaveButton || '#7737a9',
        '&:hover': {
            background: theme.palette.cgc?.bgCardFront || '#c4c4c4',
            color: theme.palette.cgc?.hoverButtonColor || '#000000',
        },
    },
    templatesContainer: {
        overflow: 'hidden',
        height: 'calc(95% - 110px)',
        padding: '0px 10px',
        margin: '0 auto',
        maxHeight: '100%',
        overflowY: 'auto',
        [theme.breakpoints.down('xs')]: {
            height: 'calc(100% - 140px)',
            padding: 0,
            overflowX: 'hidden',
            margin: '0 auto',
        },
    },
    buttonWrapper: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'space-around',
        paddingLeft: 40,
        [theme.breakpoints.down('xs')]: {
            marginTop: 0,
        },
    },
    openButton: {
        outline: 'none',
        fontWeight: 600,
        border: 'none',
        borderBottom: `2px solid ${theme.palette.cgc?.openBottomBorder || '#999'}`,
        background: 'transparent',
    },
    saveButtonWrapperChild: {
        bottom: 0,
        right: 0,
        width: '100%',
        position: 'fixed',
        [theme.breakpoints.up('767')]: {
            position: 'absolute',
            textAlign: 'right',
            bottom: '10px',
            right: '25px',
            '& button': {
                width: '175px',
            },
        },
    },
});

const CARD_STATE = {
    OPEN: 'OPEN CARD',
    CLOSE: 'CLOSE CARD',
};

const PersonalizeCard = ({
    classes,
    onSave,
    selectedCard,
    setCardMessage,
    messageData,
    isEditMode,
    toolsFontData,
}) => {
    const [cardOpen, toggleCard] = useState(!isEditMode);
    const isHorizontal = selectedCard?.card_orientation === 'Horizontal';
    return (
        <Grid className={classes.templatesContainer}>
            {
                cardOpen
                    ? (
                        <CardInside
                            setCardMessage={setCardMessage}
                            messageData={messageData}
                            toolbarProps={toolsFontData}
                            isHorizontal={isHorizontal}
                        />
                    )
                    : (
                        <CardFrontSide
                            selectedCard={selectedCard}
                            isHorizontal={isHorizontal}
                        />
                    )
            }
            <div className={classes.buttonWrapper}>
                <button
                    type="submit"
                    onClick={() => toggleCard(!cardOpen)}
                    className={classes.openButton}
                >
                    {cardOpen ? CARD_STATE.CLOSE : CARD_STATE.OPEN}
                </button>
            </div>
            <Grid item xs={12} sm={3} className={classes.saveButtonWrapperChild}>
                <Button variant="contained" className={classes.saveButton} onClick={onSave} disabled={!(messageData?.text?.trim()?.length > 0)}>
                    Save and Review
                </Button>
            </Grid>
        </Grid>
    );
};
PersonalizeCard.propTypes = {
    selectedCard: shape({
        front_view: shape({
            card_image: shape({
                url: string,
            }),
        }),
        title: string,
        card_orientation: string,
        uid: string,
    }).isRequired,
    setCardMessage: func.isRequired,
    classes: object.isRequired,
    onSave: func.isRequired,
    messageData: shape({
        text: string,
    }).isRequired,
    isEditMode: bool.isRequired,
    toolsFontData: arrayOf(shape({
        value: string,
        label: string,
        icon: object,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    })),
};
PersonalizeCard.defaultProps = {
    toolsFontData: [],
};
export default withStyles(styles)(PersonalizeCard);
